module.exports = __webpack_public_path__ + "static/media/student3.818c3d72.png";